import type { InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & {
    value: number | null;
    onChange: (value: number | null) => void;
};

const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/**
 * Campo em reais com máscara: mostra "R$ 106.120,44" e os dígitos entram pelos centavos
 * (digitar 1, 2, 3 → R$ 1,23). Guarda o valor numérico.
 */
export default function MoneyInput({ value, onChange, ...props }: Props) {
    return (
        <input
            {...props}
            type="text"
            inputMode="numeric"
            value={value == null ? '' : formatter.format(value)}
            onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
                onChange(digits === '' ? null : Number(digits) / 100);
            }}
        />
    );
}
